import React, { useEffect } from "react";

import WelcomeSection from '../../shared/components/WelcomeSection/WelcomeSection';
import unsubscribeBannerImg from '../../utils/assets/home/bg1.png';
import NavegationInfo from "../../shared/components/NavegationInfo/NavegationInfo";
import Cancelation from '../components/Cancelation/Cancelation';

 

const CancelService = props => {
    useEffect(()=>{
        window.scroll(0,0);
      },[])
     const legendInfo =
     {
         cardTitle: "Cancel",
         cardButtonText: "",
         lengendBackground: unsubscribeBannerImg
     }

    return (
        <React.Fragment>
            <WelcomeSection props={legendInfo}/>
            <NavegationInfo page="Cancel service"/>
            <Cancelation/>
        </React.Fragment>
    );
};

export default CancelService;